export default "__VITE_ASSET__350dccb3__"